var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIdBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M18.375 1H5.625C4.452 1 3.5 1.924 3.5 3.063v17.875C3.5 22.075 4.452 23 5.625 23h12.75c1.173 0 2.125-.924 2.125-2.063V3.063C20.5 1.925 19.548 1 18.375 1zm-8.5 1.375h4.25a.7.7 0 01.708.688.7.7 0 01-.708.687h-4.25a.7.7 0 01-.708-.688.7.7 0 01.708-.687zM12 7.875c1.563 0 2.833 1.233 2.833 2.75s-1.27 2.75-2.833 2.75c-1.563 0-2.833-1.233-2.833-2.75s1.27-2.75 2.833-2.75zm4.958 10.175c0 .455-.442.825-.991.825H8.033c-.549 0-.991-.37-.991-.825v-.825c0-1.366 1.332-2.475 2.975-2.475h.221a4.692 4.692 0 003.524 0h.221c1.643 0 2.975 1.109 2.975 2.475v.825z"
  }))));
}

export default SvgIdBadge;